// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  min-width: 340px;
  max-width: 95vw;
  box-shadow: 0 2px 16px rgba(0,0,0,0.18);
}

.modal h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
}

.btn {
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
}

.btn-primary {
  background: #e87722;
  color: #fff;
}

.btn-secondary {
  background: #eee;
  color: #222;
}

/* Ajoute dans CreationComptesModal.css si pas déjà présent */
.switch {
  position: relative;
  display: inline-block;
  width: 5rem;
  height: 2.4rem;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0 !important;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E5E7EB;
  transition: .4s;
  border-radius: 2.4rem;
}

.slider:before {
  position: absolute;
  content: "";
  height: 1.8rem;
  width: 1.8rem;
  left: 0.3rem;
  bottom: 0.3rem;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #DA7027;
}

input:checked + .slider:before {
  transform: translateX(2.6rem);
}

.creation-comptes .form-group label {
    font-weight: 700;
    margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/composants/CreationComptesModal/CreationComptesModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 8px;\n  padding: 2rem;\n  min-width: 340px;\n  max-width: 95vw;\n  box-shadow: 0 2px 16px rgba(0,0,0,0.18);\n}\n\n.modal h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n}\n\n.btn {\n  padding: 0.5rem 1.2rem;\n  border-radius: 4px;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.btn-primary {\n  background: #e87722;\n  color: #fff;\n}\n\n.btn-secondary {\n  background: #eee;\n  color: #222;\n}\n\n/* Ajoute dans CreationComptesModal.css si pas déjà présent */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 5rem;\n  height: 2.4rem;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0 !important;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #E5E7EB;\n  transition: .4s;\n  border-radius: 2.4rem;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 1.8rem;\n  width: 1.8rem;\n  left: 0.3rem;\n  bottom: 0.3rem;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #DA7027;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(2.6rem);\n}\n\n.creation-comptes .form-group label {\n    font-weight: 700;\n    margin-bottom: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
